import React, { useState } from "react";
import Swal from "sweetalert2";

function SubscribeForm() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formURL =
      "https://docs.google.com/forms/d/e/1FAIpQLScvqKLK4mEaWWUzBOONqG2o80PmA88PJtwBESVdrmm2au4liA/formResponse";

    const fd = new FormData();
    fd.append("entry.316285278", email);

    await fetch(formURL, {
      method: "POST",
      mode: "no-cors",
      body: fd,
    });

    setEmail("");

    Swal.fire({
      title: "Form Submitted!",
      text: "Welcome aboard! 🎉 You’re now part of our community. Stay tuned for exciting updates.",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex">
        <input
          className="form-control me-3"
          placeholder="Enter your email address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button className="btn btn-primary footer-btn" type="submit">
          Subscribe
        </button>
      </div>
    </form>
  );
}

export default SubscribeForm;